const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://concreto-m4u1.onrender.com'; // Backend conection

// Faz parse do corpo como JSON; devolve null se vazio e o texto cru se não for JSON válido.
async function parseJsonSafely(response) {
  const text = await response.text();
  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch (error) {
    return text;
  }
}

// Ponto único de saída HTTP: injeta o token Bearer, define Content-Type (exceto FormData)
// e lança Error com .status/.data quando a resposta não é ok.
export async function request(path, options = {}) {  // api request config
  let token = localStorage.getItem('token'); // Remove "" from request token
  if (token) {
    token = token.replace(/"/g, '');
  }

  const headers = {
    ...(options.headers || {}),
  };

  if (options.body && options.body instanceof FormData) {
    // Let the browser automatically set the Content-Type with the correct boundary
    delete headers['Content-Type'];
  } else {
    headers['Content-Type'] = headers['Content-Type'] || 'application/json';
  }

  if (token) {  // Turns Token into Bearer format
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers,
  });

  const data = await parseJsonSafely(response);

  if (!response.ok) {
    const message =
      (data && data.message) || `Request failed with status ${response.status}`;
    const error = new Error(message);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}
